import React from 'react'

export default function ThankYou() {
  return (
    <>
    <div className="banner-wrapper">
        <div className="banner">
            <div className="banner-text-wrapper">
                <div className="banner-text">
                    MIRUM LIBRARY<br/>
                    <span>GET YOUR COMPLIMENTARY COPY OF <i>FRANKIE FINDS HER VOICE</i></span>
                </div>
            </div>
            <div className="book-girl">
                <img src="./images/frankie.png" alt="Frankie Finds Her Voice" />
            </div>
        </div>
    </div>

    <div className="main">
      <div className="thank-you-content">
        <div className="text-center">
          <img src="./images/confirmation-checkmark.png" alt="" height="75" />
        </div>

        <div className="thank-you-heading">
          Order submitted
        </div>
        
        <div className="thank-you-large">
          Thanks, and happy reading!
        </div>
        
        <div className="thank-you-bottom">
          We'll send a confirmation to your email inbox shortly.
          <div className="mt10">
            Your book will ship once your order has been processed.
          </div>
        </div>
      </div>
    </div>
    </>
  )
}
